import "~assets/css/index.css";
import * as echarts from "echarts/core";
import { createApp } from "vue";
import echartDarkTheme from "~ui/@application/configs/echart-dark-theme.ts";
import { createVoltexploitRouter } from "~ui/@application/configs/router-config.ts";
import { loadConfig } from "~ui/@application/configs/runtime-config.ts";
import { createServices } from "~ui/@application/di.ts";
import { voltexploitI18nConfigurationPlugin } from "~ui/@application/plugins/i18n-plugin.ts";
import { voltexploitPiniaConfigurationPlugin } from "~ui/@application/plugins/pinia-plugin.ts";
import { voltexploitPrimevueConfigurationPlugin } from "~ui/@application/plugins/primevue-plugin.ts";
import { voltexploitSentryonfigurationPlugin } from "~ui/@application/plugins/sentry-plugin.ts";
import { voltexploitTanstackConfigurationPlugin } from "~ui/@application/plugins/tanstack-plugin.ts";
import { provideConfigPlugin, provideServicesPlugin } from "~ui/@application/provider.ts";
import App from "~ui/@core/app.vue";

echarts.registerTheme("dark", echartDarkTheme);

const config = loadConfig();

createServices(config).then((services) => {
  const app = createApp(App);

  const router = createVoltexploitRouter(config);
  app.use(router);

  app.use(provideConfigPlugin, { config: config });

  app.use(provideServicesPlugin, { services: services });

  app.use(voltexploitI18nConfigurationPlugin, { config: config });
  app.use(voltexploitPiniaConfigurationPlugin, { config: config });

  app.use(voltexploitPrimevueConfigurationPlugin, { config: config });
  app.use(voltexploitTanstackConfigurationPlugin, { config: config });
  app.use(voltexploitSentryonfigurationPlugin, {
    config: config,
    router: router,
  });

  app.mount("#app");
});
